/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { SEARCH_BAR_CLICK } from '@zcode-ui/web-zumper-integrations'
import { event } from '@zcode/integrations'
import { EVENT_NAMES, type PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { Dispatch } from '@zcode/state-type'

export type Keys = keyof typeof PAGE_NAMES
export type PageNameValues = (typeof PAGE_NAMES)[Keys]

export const trackSearchBarClick =
  ({ pageName }: { pageName: PageNameValues }) =>
  (dispatch: Dispatch) => {
    track({
      event: EVENT_NAMES.CLICK,
      payload: { [PROP_NAMES.PAGE_NAME]: pageName, [PROP_NAMES.BUTTON_CLICKED]: 'Search bar' },
    })
    dispatch(event({ name: SEARCH_BAR_CLICK, props: { pageType: pageName } }))
  }
